export default "__VITE_ASSET__CgP0gMa$__"